export const BASE_URL = process.env.REACT_APP_API_BASEURL;
export const EVOLVE_ME_URL = process.env.REACT_APP_EVOLVE_ME_URL;
export const ENDPOINTS = {
  GET_TASKS: (id) => `tasks/${id}`,
  COMPLETE_TASKS: `tasks`,

  ANALYTICS_EVENT: `${BASE_URL}analytics`
};
